/** Shared by the real React SSR tree and the legacy snapshot builder. */
import { publicDisplayName } from "@workspace/booking-rules/public-name";
export function publicHostReviewHeadline(profile) {
  if (profile.reviewStats) return profile.reviewStats;
  const ratings = (profile.reviews || []).map(r => Number(r.rating))
    .filter(n => Number.isFinite(n) && n >= 1 && n <= 5);
  return {
    averageRating: ratings.length ? ratings.reduce((sum, n) => sum + n, 0) / ratings.length : null,
    reviewCount: ratings.length,
  };
}

export function publicReviewerName(person, fallback = "Guest") {
  return publicDisplayName(person) || fallback;
}

export function publicReviewDate(value, language = "en") {
  const date = new Date(value);
  return Number.isFinite(date.getTime())
    ? new Intl.DateTimeFormat(language, { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" }).format(date)
    : "";
}
